import React, { useEffect, useState } from "react";
import PageHeader from "../../components/ui/PageHeader";
import leaveService from "../../services/leaveService";
import { useToast } from "../../contexts/ToastContext";
import { getErrorMessage } from "../../utils/errorHandler";
import LeaveRequestTable from "../../components/common/LeaveRequestTable";
import { History } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../../styles/dashboard.css";

const LeaveRequestsRH = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [pendingRequests, setPendingRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    setLoading(true);
    try {
      const data = await leaveService.getLeaveRequestsRH();
      setPendingRequests(data || []);
      setFilteredRequests(data || []);
    } catch (err) {
      console.error(err);
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (filter === "all") {
      setFilteredRequests(pendingRequests);
    } else {
      setFilteredRequests(pendingRequests.filter(req => req.status === filter));
    }
  }, [filter, pendingRequests]);


const handleDecision = async (requestId, action) => {
  const approved = action === "Approuver";
  const comment = approved
    ? "Validé par les RH"
    : "Refusé par les RH";

  console.group(`[RH] Décision sur la demande ${requestId}`);
  console.log("Action :", action);
  console.log("Valeur approved :", approved);
  console.log("Commentaire :", comment);

  try {
    const res = await leaveService.hrDecision(
      requestId,
      approved,
      comment
    );

    console.log("Réponse complète du backend :", res);
    console.log("Statut retourné :", res?.status);

    if (res?.status === "APPROVED") {
      toast.success("Demande approuvée définitivement.");
    } else if (res?.status === "REJECTED") {
      toast.error("Demande refusée : vérifiez le solde et les règles RH.");
    } else {
      toast.warning(
        `Le serveur a répondu avec le statut "${res?.status ?? "inconnu"}".`
      );
    }

    await load();
    console.log("Liste des demandes rechargée.");
  } catch (err) {
    console.error("Erreur pendant la décision RH :", err);
    console.error("Réponse serveur :", err?.response?.data);
    toast.error(
      getErrorMessage(err, "Impossible de traiter cette demande.")
    );
  } finally {
    console.groupEnd();
  }
};


  return (
    <div style={{ padding: "24px" }}>
      <PageHeader
        title="Validations des Congés RH"
        subtitle="Consultez les demandes en attente de validation par le Manager ou validez celles transmises par les managers."
        actions={
          <button
            onClick={() => navigate("/rh/leaves/history")}
            className="btn btn-outline"
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <History size={16} />
            <span>Voir l'historique complet</span>
          </button>
        }
      />

      <div className="ui-card" style={{ padding: "20px" }}>
        <div style={{ marginBottom: "20px", display: "flex", gap: "10px", alignItems: "center" }}>
          <span style={{ fontSize: "14px", color: "#6b7280" }}>Filtrer par statut :</span>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{ padding: "6px 12px", borderRadius: "6px", border: "1px solid #d1d5db", fontSize: "14px" }}
          >
            <option value="all">Tous</option>
            <option value="PENDING_MANAGER">En attente Manager</option>
            <option value="PENDING_HR">En attente RH</option>
          </select>
        </div>
        {loading ? (
          <div style={{ padding: "40px", textAlign: "center", color: "var(--text-muted)" }}>
            Chargement des demandes RH...
          </div>
        ) : (
          <LeaveRequestTable
            requests={filteredRequests}
            role="rh"
            onAction={(id, action) => handleDecision(id, action)}
          />
        )}
      </div>
    </div>
  );
};

export default LeaveRequestsRH;

